<template>
  <div id="batchtrackitem">
    <div class="batchtrack-wrap relative">
      <div class="batch batch-bg mb-2 cursor-pointer" @click="toggleBatchTrackItemModal(trackItem)">
        <!-- batch name and quantity -->
        <div class="flex justify-between text-dark font-medium text-sm">
          <p>{{ trackItem.batch_name }}</p>
          <p>{{ trackItem.quantity }}</p>
        </div>

        <!-- room purpose -->
        <div class="flex justify-between text-dark font-medium text-sm py-4">
          <p>{{ trackItem.location && trackItem.location.name }}</p>
          <p v-if="board.boardDataPayloads.drying">
            {{ trackItem.drying ? 'Drying' : 'Dried' }}
          </p>
        </div>

        <!-- batch number and actions -->
        <div class="flex justify-between text-dark font-medium text-sm">
          <p>{{ trackItem.batch_number }}</p>
        </div>
      </div>

      <div class="vx-col ml-auto absolute batch-setting" v-if="board.isHaveActions && !isArchievedList">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div class="cursor-pointer flex items-center justify-between font-medium">
            <feather-icon icon="SettingsIcon" svgClasses="h-6 w-6 settings-icon" class="ml-1" />
          </div>
          <vs-dropdown-menu class="invoice__actions">
            <vs-dropdown-item class="p-2 items-center justify-center" @click="handleActionCallback(item, trackItem)" v-for="(item, index) in board.boardActions" :key="index">
              <div class="flex items-center">
                <span class="ml-2 text-base block whitespace-no-wrap">{{ item.label }}</span>
              </div>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>

    <!-- create batch package -->
    <!-- <create-batch-package v-if="isCreateBatchPackageModalMounted" :isCreateBatchPackageShow.sync="isCreateBatchPakcageModalShow" :batchDetails="selectedBatch" /> -->
    <!-- destroy batch plants -->
    <destroy-batch-plants
      v-if="isDestroyBatchPlantModalMounted"
      :isModalShow.sync="isDestroyBatchPlantModalShow"
      :batchId="selectedBatch.id"
      :destroyPlantStages="reqPlantStages"
      @done="$root.$emit('batchTrackdataUpdated')"
    />
    <!-- add plant -->
    <!-- <add-plant v-if="isAddBatchPlantModalMounted" :addPlantModalShow.sync="isAddBatchPlantModalShow" :batchId="selectedBatch.id" @done="$root.$emit('dataUpdated')" /> -->
    <!-- assign plant tag -->
    <!-- <assign-plant-tag v-if="isAssignPlantTagModalMounted" :isAssignPlantTagModal.sync="isAssignPlantTagModalShow" :batchId="selectedBatch.id" @done="$root.$emit('dataUpdated')" /> -->
    <!-- change growth phase -->
    <change-growth-phase
      v-if="isChangeGrowthPhaseModalMounted"
      :isModalShow.sync="isChangeGrowthPhaseModalShow"
      :batchId="selectedBatch.id"
      :plantStages="reqPlantStages"
      @done="$root.$emit('batchTrackdataUpdated')"
    />
    <!-- report waste modal -->
    <!-- <report-waste-modal v-if="isRecordWasteModalMounted" :active.sync="isRecordWasteModalShow" :batchId="selectedBatch.id" /> -->
    <!-- Create Harvest Modal -->
    <!-- <create-harvest-model v-if="isCreateHarvestModalMounted" :active.sync="isCreateHarvestModalShow" :batchId="selectedBatch.id" @done="$root.$emit('dataUpdated')" /> -->
    <!-- batch track item modal -->
    <batch-track-item-modal
      v-if="isBatchTrackItemModalMounted"
      :active.sync="isBatchTrackItemModalShow"
      :batch="selectedBatch"
      :board="board"
      :isArchievedList="isArchievedList"
      :dryingStat="trackItem.drying"
    />
    <!-- update batch status modal -->
    <update-batch-status-modal v-if="isUpdateBatchStatusModalMounted" :isModalShow.sync="isUpdateBatchStatusModalShow" :batch="selectedBatch" @done="$root.$emit('batchTrackdataUpdated')" />
    <!-- update batch location modal -->
    <update-batch-location-modal v-if="isUpdateBatchLocationModalMounted" :isModalShow.sync="isUpdateBatchLocationModalShow" :batch="selectedBatch" @done="$root.$emit('batchTrackdataUpdated')" />
  </div>
</template>

<script>
// import CreateBatchPackage from '@/views/batches/components/CreateBatchPackage'
import DestroyBatchPlants from '@/views/batches/components/modals/plants/DestroyBatchPlants'
// import AddPlant from '@/views/batches/components/modals/plants/AddPlant'
// import AssignPlantTag from '@/views/batches/components/modals/plants/AssignPlantTag'
import ChangeGrowthPhase from '@/views/batches/components/modals/plants/ChangeGrowthPhase'
// import ReportWasteModal from '@/views/batches/components/ReportWasteModal.vue'
// import CreateHarvestModel from '@/views/batches/components/CreateHarvestBatch.vue'
import BatchTrackItemModal from '@/views/batches/components/modals/batch/BatchTrackItemModal'
import UpdateBatchStatusModal from '@/views/batches/components/modals/batch/BatchStatusUpdateModal'
import UpdateBatchLocationModal from '@/views/batches/components/modals/batch/BatchLocationUpdateModal'

export default {
  name: 'BatchTrackItem',

  props: {
    trackItem: {
      type: Object,
      default: () => {}
    },

    board: {
      type: Object,
      default: null
    },

    isArchievedList: {
      type: Boolean,
      default: false
    }
  },

  components: {
    // CreateBatchPackage,
    DestroyBatchPlants,
    // AddPlant,
    // AssignPlantTag,
    ChangeGrowthPhase,
    // ReportWasteModal,
    // CreateHarvestModel,
    BatchTrackItemModal,
    UpdateBatchStatusModal,
    UpdateBatchLocationModal
  },

  data() {
    return {
      selectedBatch: null,

      // create package
      isCreateBatchPackageModalMounted: false,
      isCreateBatchPakcageModalShow: false,

      // destroy batch plants
      isDestroyBatchPlantModalMounted: false,
      isDestroyBatchPlantModalShow: false,

      // add batch plants
      isAddBatchPlantModalMounted: false,
      isAddBatchPlantModalShow: false,

      // assign plant tag modal
      isAssignPlantTagModalMounted: false,
      isAssignPlantTagModalShow: false,

      // change growth phase
      isChangeGrowthPhaseModalMounted: false,
      isChangeGrowthPhaseModalShow: false,

      // record waste modal
      isRecordWasteModalMounted: false,
      isRecordWasteModalShow: false,

      // create harvest modal
      isCreateHarvestModalMounted: false,
      isCreateHarvestModalShow: false,

      // batch track item popup modal
      isBatchTrackItemModalMounted: false,
      isBatchTrackItemModalShow: false,

      // update batch status modal
      isUpdateBatchStatusModalMounted: false,
      isUpdateBatchStatusModalShow: false,

      // update batch status location
      isUpdateBatchLocationModalMounted: false,
      isUpdateBatchLocationModalShow: false
    }
  },

  mounted() {
    this.$root.$on('handleCloseAllModal', () => {
      this.handleDestroyAllModal()
    })
  },

  computed: {
    reqPlantStages() {
      return this.board.boardDataPayloads.drying ? (this.trackItem.drying ? ['Drying'] : ['Dried']) : (this.board && this.board.boardDataPayloads && this.board.boardDataPayloads.plantStages) || []
    }
  },

  methods: {
    // handle action callback
    handleActionCallback(item, data) {
      this[item.action](data)
    },

    // create batch package
    createPackageFromBatch(data) {
      this.selectedBatch = data
      this.isCreateBatchPackageModalMounted = true
      this.isCreateBatchPakcageModalShow = true
    },

    // redirect to create product
    redirectToCreateProduct(data) {
      this.$router.push({ name: 'product-create', query: { batch_number: data.batch_number, batchId: data.id } })
    },

    // redirect to print label
    redirectToPrintLabel(data) {
      this.$router.push({ name: 'batch-print-label', params: { batchId: data.id } })
    },

    // redirect to view plants
    redirectToViewPlants(data) {
      this.$router.push({ name: 'view-batch', params: { id: data.id } })
    },

    // redirect to edit batch
    redirectToEditBatch(data) {
      this.$router.push(`/batches/${data.id}/edit`)
    },

    // destroy batch plants
    destroyBatchPlants(data) {
      this.selectedBatch = data
      this.isDestroyBatchPlantModalMounted = true
      this.isDestroyBatchPlantModalShow = true
    },

    // add batch plants
    addBatchPlant(data) {
      this.selectedBatch = data
      this.isAddBatchPlantModalMounted = true
      this.isAddBatchPlantModalShow = true
    },

    // assign plant tag
    assignPlantTag(data) {
      this.selectedBatch = data
      this.isAssignPlantTagModalMounted = true
      this.isAssignPlantTagModalShow = true
    },

    // change growth phase
    changeGrowthPhase(data) {
      this.selectedBatch = data
      this.isChangeGrowthPhaseModalMounted = true
      this.isChangeGrowthPhaseModalShow = true
    },

    // record waste modal
    recordWaste(data) {
      this.selectedBatch = data
      this.isRecordWasteModalMounted = true
      this.isRecordWasteModalShow = true
    },

    // create harvest modal
    createHarvestModal(data) {
      this.selectedBatch = data
      this.isCreateHarvestModalMounted = true
      this.isCreateHarvestModalShow = true
    },

    // redirect to batch weight summary
    redirectToBatchWeightSummay(data) {
      this.$router.push({ name: 'view-batch', params: { id: data.id }, query: { activeTab: 3 } })
    },

    // redirect to archieve batch plants
    redirectToArchivedPlants(data) {
      this.$router.push({ name: 'archive-batch-plants', params: { batchId: data.id } })
    },

    // toggle track item modal
    toggleBatchTrackItemModal(data) {
      if (this.board.isHaveModal) {
        this.selectedBatch = data
        this.isBatchTrackItemModalMounted = true
        this.isBatchTrackItemModalShow = true
      }
    },

    // toggle update batch status modal
    toggleUpdateBatchStatusModal(data) {
      this.selectedBatch = data
      this.isUpdateBatchStatusModalMounted = true
      this.isUpdateBatchStatusModalShow = true
    },

    // toggle update batch location modal
    toggleUpdateBatchLocationModal(data) {
      this.selectedBatch = data
      this.isUpdateBatchLocationModalMounted = true
      this.isUpdateBatchLocationModalShow = true
    },

    // destroy all modal
    handleDestroyAllModal() {
      this.isCreateBatchPakcageModalShow = false
      this.isDestroyBatchPlantModalShow = false
      this.isAddBatchPlantModalShow = false
      this.isAssignPlantTagModalShow = false
      this.isChangeGrowthPhaseModalShow = false
      this.isRecordWasteModalShow = false
      this.isCreateHarvestModalShow = false
      this.isBatchTrackItemModalShow = false
      this.isUpdateBatchStatusModalShow = false
      this.isUpdateBatchLocationModalShow = false
    }
  },

  watch: {
    // handle callback for create batch package
    isCreateBatchPakcageModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isCreateBatchPackageModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for destroy batch package
    isDestroyBatchPlantModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isDestroyBatchPlantModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for add batch plant
    isAddBatchPlantModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isAddBatchPlantModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for assign plant tag
    isAssignPlantTagModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isAssignPlantTagModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for change growth phase
    isChangeGrowthPhaseModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isChangeGrowthPhaseModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for reset waste modal
    isRecordWasteModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isRecordWasteModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for create harvest modal
    isCreateHarvestModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isCreateHarvestModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for toggle batch track item modal
    isBatchTrackItemModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isBatchTrackItemModalMounted = false
            this.selectedBatch = null
          }, 0)
        }
      }
    },

    // handle callback for update batch status
    isUpdateBatchStatusModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isUpdateBatchStatusModalMounted = false
          }, 0)
        }
      }
    },

    // handle callback for update batch location
    isUpdateBatchLocationModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isUpdateBatchLocationModalMounted = false
          }, 0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#batchtrackitem {
  .batch {
    width: 100%;
    padding: 10px;

    &.batch-bg {
      background-color: #f6f8fe;
      border-radius: 10px;
      transition: all 0.5s;
      border: 2px solid transparent;
      &:hover {
        background-color: transparent;
        border: 2px solid #28c76f;
      }
    }

    &:first-child {
      margin-top: 0;
    }

    .settings-icon {
      color: #28c76f;
    }
  }

  .batch-setting {
    bottom: 0.6rem;
    right: 0.8rem;
    color: #28c76f;
  }
}
</style>
